import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import ContactHeroSection from '../components/contact-page/ContactHeroSection';
import ContactChannelsSection from '../components/contact-page/ContactChannelsSection';
import ContactFormSection from '../components/contact-page/ContactFormSection';
import ContactFaqSection from '../components/contact-page/ContactFaqSection';
import ContactQuickAccessSection from '../components/contact-page/ContactQuickAccessSection';

export default function ContactPage() {
  const { language } = useI18n();
  const title = language === 'fr' ? 'Contactez ETC Company' : 'Contact ETC Company';
  const description =
    language === 'fr'
      ? 'Contactez ETC Company pour un devis, un support machine ou une question technique.'
      : 'Contact ETC Company for quotes, machine support, or technical questions.';

  return (
    <div className="bg-[var(--dash-blacker)]">
      <Seo
        title={title}
        description={description}
        keywords={{
          en: ['contact ETC Company', 'request a quote', 'after sales support', 'machine support', 'technical questions'],
          fr: ['contacter ETC Company', 'demande de devis', 'support après vente', 'support machine', 'questions techniques'],
        }}
      />
      <ContactHeroSection />
      <ContactChannelsSection />
      <ContactFormSection />
      <ContactFaqSection />
      <ContactQuickAccessSection />
    </div>
  );
}
